import React from 'react';
import Header from '../common/header';
import CareerPageHeader from '../layout/career/careerPageHeader';
import CareerMain from '../layout/career/careerMain';
import CareerBucket from '../layout/career/careerBucket';
import Footer from '../common/footer';
import About1 from '../layout/about/about1';



function Careers(){
    return(
        <>
        <Header/>
        <br/>
        <CareerPageHeader/>
        <br/>
        <CareerMain/>
        <br/>
        <CareerBucket/>
        <br/>
        <Footer/>
        </>
    )
}
export default Careers;